import { createAction, props } from '@ngrx/store'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { MetricDetailContext, MetricDetailed } from '@features/metric-detail/models/metric-detail.models'

export const fetchMetricDetail = createAction(
  '[Metric Detail] fetch metric detail',
  props<{ payload: ContextMenuItemEvent }>()
)

export const setMetricDetailLoader = createAction(
  '[Metric Detail] set metric detail loader',
  props<{ loading: boolean }>()
)

export const setMetricDetailSourceMetric = createAction(
  '[Metric Detail] set source metric',
  props<{ sourceMetric: ListedMetric | ComparableMetric }>()
)

export const setMetricDetailItems = createAction('[Metric Detail] set items', props<{ items: MetricDetailed[] }>())

export const setMetricDetailContext = createAction('[Metric Detail] set context', props<MetricDetailContext>())

export const openMetricDetailModal = createAction(
  '[Metric Detail] open modal',
  props<{ payload: MetricDetailContext }>()
)

export const closeMetricDetailModal = createAction('[Metric Detail] close modal')

export const purgeMetricDetail = createAction('[Metric Detail] purge metric detail')
